import React from 'react';
import { useAITTheme } from '../ui/theme';

const BaseIcon: React.FC = () => {
  const { theme } = useAITTheme();
  return (
    <svg width="16" height="16" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 100 100">
      <path
        fill={theme.tokens.colors.brand.primary}
        fillRule="evenodd"
        d="M79.53,3.94c-16.05,6.22-25.73,3.18-35.98-.04-11.02-3.46-22.43-7.05-40.94.04C1.13,4.51.14,5.94.15,7.54v88.46c0,2.12,1.72,3.85,3.85,3.85s3.85-1.72,3.85-3.85v-35.7c10.86-3.92,22.8-3.58,33.42.94,15.69,5.43,28.58,5.43,41.04-.13,1.45-.6,2.42-2,2.46-3.57V7.54c-.02-2.15-1.78-3.87-3.92-3.85-.45,0-.89.09-1.31.24h0ZM77.07,54.85c-14.62,5-23.8,2.12-33.5-.93-11.38-4.58-23.96-5.2-35.73-1.76V10.23c14.54-4.92,23.72-2.04,33.41,1.01,9.98,3.12,20.26,6.36,35.82,1.68v41.92Z"
      />
    </svg>
  );
};

export default BaseIcon;
